<header id="page-topbarx" data-scroll-header>
  <div class="layout-width">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="ms-1 header-item d-none d-sm-flex">
          <button
            class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            placement="bottom"
            tooltipClass="custom-tooltip-success"
            type="button"
          >
            <i class='bi bi-building-add fs-22'></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
